<div class="auth-container">
    <div class="auth-header"></div>
    <div class="auth-body">
        <img
            class="app-logo"
            src="/assets/icons/moveright-simplified.svg"
            alt="Move Right Moving Simplified"
            width="256px"
            height="256px"
        />

        <app-auth [showHeader]="false"></app-auth>
    </div>
    <app-auth-footer supportMessage="I'm having trouble on the login page"></app-auth-footer>
</div>